import {
  CircularProgress,
  FormControl,
  MenuItem,
  Select,
  styled,
} from "@mui/material";
import { useState } from "react";
import { useBranch } from "../../Hooks/useBranch";
import { useNotification } from "../../Hooks/useNotification";
import useTokenRefresh from "../../Hooks/useTokenRefresh";
import { useApiErrorHandler } from "../../Hooks/useApiErrorHandler";
import httpclient from "../../Utils";
import { useDelayPicking } from "../../Hooks/useDelayPicking";

const BranchDiv = styled("div")(({ theme }) => ({
  width: "240px",
  display: "flex",
  alignItems: "center",
  height: "40px",
  backgroundColor: "#fff",
  borderRadius: "4px",
}));

const BranchSection = () => {
  const [loading, setLoading] = useState(false);

  const { branches, currentBranch, setCurrentBranch } = useBranch();
  const showNotification = useNotification();
  const { setIsDelayPicking } = useDelayPicking();

  const { getTokenRefreshed: refresh } = useTokenRefresh();
  const handleApiError = useApiErrorHandler();

  const login = localStorage.getItem("user");
  const loginData = JSON.parse(login);

  const updateBranch = async (newBranch) => {
    const endpoint = "/dashboard/update-branch";

    try {
      setLoading(true);

      const res = await httpclient.post(endpoint, {
        branch: newBranch,
      });

      const { data } = res;

      if (data.status === 200) {
        setCurrentBranch(data.data.branch_code);
        setIsDelayPicking(true);
        showNotification("success", data.message);
      } else {
        showNotification("error", data.message);
      }
    } catch (error) {
      if (error.response.status === 401) {
        refresh();
      } else {
        handleApiError(error);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleBranchChange = (event) => {
    updateBranch(event.target.value);
  };

  return (
    <BranchDiv>
      <FormControl fullWidth>
        <Select
          value={currentBranch}
          onChange={handleBranchChange}
          variant="outlined"
          size="small"
          disabled={loading || loginData.is_system_admin !== 1}
          selectprops={{
            IconComponent: loading ? () => null : undefined,
          }}
          sx={{
            height: "32px",
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            position: "relative",
          }}
        >
          {branches &&
            branches.map((branch) => (
              <MenuItem key={branch.branch_code} value={branch.branch_code}>
                {branch.branch_name}
              </MenuItem>
            ))}
        </Select>
        {loading && (
          <CircularProgress
            size={20}
            sx={{
              position: "absolute",
              top: "50%",
              right: "10px",
              transform: "translateY(-50%) !important",
            }}
          />
        )}
      </FormControl>
    </BranchDiv>
  );
};

export default BranchSection;
